import { type ComponentProps, type FC, memo } from "react";

import { cn } from "../../utils/general";
import { Skeleton } from "../skeleton";

export const EmailDraftRecipientsSkeleton: FC<ComponentProps<typeof Skeleton>> = memo(({ className, ...props }) => (
  <div className="flex flex-row flex-wrap gap-1">
    {Array.from({ length: 2 }).map((_, index) => (
      <Skeleton
        {...props}
        key={index}
        style={{ width: `${Math.random() * (180 - 60) + 60}px` }}
        className={cn("h-6 rounded-sm", className)}
      />
    ))}
  </div>
));
EmailDraftRecipientsSkeleton.displayName = "EmailDraftRecipientsSkeleton";
